<template>
    <div class="center">
        <Card class="card">
            <template #header>
                <!-- <img alt="user header" src="demo/images/usercard.png"> -->
            </template>

            <template #title>
                Admin Portal
            </template>

            <template #content>
                <TabView v-model:activeIndex="activeIndex">
                    <TabPanel header="Statistics">
                        <div :style="{ display: 'flex', flexDirection: 'row' }">
                            <div :style="{ width: '50%' }">
                                <LineChart :data="userByMonth" :options="{
                                    plugins: {
                                        title: { display: true, text: 'User Registered by Time' },
                                        legend: { position: 'bottom' }
                                    },
                                    interaction: {
                                        intersect: false,
                                        mode: 'index'
                                    },
                                }" :style="{ width: '100%', height: '225px' }"></LineChart>
                                <LineChart :data="companyByMonth" :options="{
                                    plugins: {
                                        title: { display: true, text: 'Company Registered by Time' },
                                        legend: { position: 'bottom' }
                                    },
                                    interaction: {
                                        intersect: false,
                                        mode: 'index'
                                    },
                                }" :style="{ width: '100%', height: '225px' }"></LineChart>
                                <LineChart :data="projectByMonth" :options="{
                                    plugins: {
                                        title: { display: true, text: 'Projects by Time' },
                                        legend: { position: 'bottom' }
                                    },
                                    interaction: {
                                        intersect: false,
                                        mode: 'index'
                                    },
                                }" :style="{ width: '100%', height: '250px' }"></LineChart>
                            </div>
                            <div :style="{ width: '50%' }">
                                <BarChart :data="projectByDistrict" :options="{
                                    indexAxis: 'y',
                                    plugins: {
                                        title: { display: true, text: 'Projects by District' },
                                        legend: { position: 'bottom' }
                                    },
                                    interaction: {
                                        intersect: false,
                                        mode: 'index',
                                        axis: 'y'
                                    },
                                }" :style="{ width: '100%', height: '450px' }"></BarChart>
                                <LineChart :data="projectAccumulative" :options="{
                                    plugins: {
                                        title: { display: true, text: 'Accumulative Projects by Time' },
                                        legend: { position: 'bottom' }
                                    },
                                    interaction: {
                                        intersect: false,
                                        mode: 'index'
                                    },
                                }" :style="{ width: '100%', height: '250px' }"></LineChart>
                            </div>
                        </div>
                        <div :style="{ display: 'flex', flexDirection: 'row' }">
                            <Button label="Export Users" style="margin: 1%;width:50%" @click="exportUsers"></Button>
                            <Button label="Export Projects" style="margin: 1%;width:50%"
                                @click="exportProjects"></Button>
                        </div>
                        <!-- <div :style="{ width: '100%' }" style="margin-top: 10px">
                            <Button label="Review Submitted Cases" class="p-button-secondary" style="margin-left: .5em"
                                @click='goProjects' />
                        </div> -->
                    </TabPanel>
                    <TabPanel header="District Admins">
                        <DataTable :value="districtAdmins" :scrollable="true" scrollHeight="400px" editMode="row"
                            v-model:editingRows="adminEditingRows" @row-edit-save="onAdminRowEditSave"
                            style="width:100%">
                            <Column field="district" header="District" style="max-width:15%" :sortable="true">
                                <template #editor="{ data, field }">
                                    <label>{{ data[field] }}</label>
                                </template>
                            </Column>
                            <Column field="firstName" header="First Name" style="max-width:15%" :sortable="true">

                                <template #editor="{ data, field }">
                                    <InputText v-model="data[field]" autofocus style="width:100%" />
                                </template>
                            </Column>
                            <Column field="lastName" header="Last Name" style="max-width:15%" :sortable="true">

                                <template #editor="{ data, field }">
                                    <InputText v-model="data[field]" autofocus style="width:100%" />
                                </template>
                            </Column>
                            <Column field="username" header="Username" style="max-width:20%">

                                <template #editor="{ data, field }">
                                    <InputText v-model="data[field]" autofocus style="width:100%" />
                                </template>
                            </Column>
                            <Column field="password" header="Password" style="max-width:20%">

                                <template #editor="{ data, field }">
                                    <InputText v-model="data[field]" autofocus style="width:100%" />
                                </template>
                            </Column>
                            <Column field="email" header="Email" style="max-width:40%">

                                <template #editor="{ data, field }">
                                    <InputText v-model="data[field]" autofocus style="width:100%" />
                                </template>
                            </Column>
                            <Column field="phone" header="Phone Number" style="max-width:20%">

                                <template #editor="{ data, field }">
                                    <InputMask id="phoneNumber" type="text" v-model="data[field]" mask="(+999)9999-9999"
                                        placeholder="(+852)9999-9999" style="width:100%" />
                                </template>
                            </Column>
                            <Column :rowEditor="true" style="width:10%; min-width:8rem" bodyStyle="text-align:center">
                            </Column>
                        </DataTable>
                    </TabPanel>
                    <TabPanel header="All Users">
                        <span class="p-input-icon-left" style="width:100%;margin-bottom: 10px;">
                            <i class="pi pi-search" />
                            <InputText v-model="searchUser" placeholder="Search" style="width:100%">
                            </InputText>
                        </span>
                        <DataTable :value="searchUser ? searchUsers() : allUsers" :scrollable="true"
                            scrollHeight="400px" removableSort style="width:100%">
                            <Column field="company" header="Company" style="max-width:30%" sortable></Column>
                            <Column field="userType" header="Role" style="max-width:15%" sortable></Column>
                            <Column field="firstName" header="First Name" style="max-width:15%"></Column>
                            <Column field="lastName" header="Last Name" style="max-width:15%"></Column>
                            <Column field="email" header="Email" style="max-width:30%"></Column>
                            <Column field="phone" header="Phone Number" style="max-width:20%"></Column>
                            <Column field="registerDate" header="Register Date" style="max-width:20%"></Column>
                            <Column field="active" header="Active" style="max-width:10%"></Column>
                            <Column header="" style="max-width:50px">

                                <template #body="slotProps">
                                    <Button :icon="slotProps.data.deleting"
                                        class="p-button-rounded p-button-danger p-button-text"
                                        @click="targetUser = slotProps.data; confirmDeleteUser($event);"
                                        v-tooltip="'Delete User'" />
                                </template>
                            </Column>
                        </DataTable>
                        <ConfirmPopup>

                            <template #message="slotProps">
                                <div class="flex p-4">
                                    <i :class="slotProps.message.icon" style="font-size: 1.5rem"></i>
                                    <p style="margin:0px 5px">Do you want to <b style="color:#c02929">PERMANENT
                                            DELETE</b>
                                        this user?</p>
                                </div>
                            </template>
                        </ConfirmPopup>
                    </TabPanel>
                    <!-- <TabPanel header="Activity">
                        <div class="verticalBoxContainer">
                            <h3>Relationship between Construction Works and Activity</h3>
                            <div class="formgrid grid">
                                <Listbox class="field col-12 md:col-5 fieldLabel" v-model="selectedCw" :options="cwActs"
                                    optionLabel="name" listStyle="max-height:200px"
                                    @change="selectedActivities=selectedCw?selectedCw.activities:[]" id="cwlist">
                                </Listbox>
                                <div class="field col-12 md:col-2 center2"><i class="pi pi-angle-double-right"
                                        style="padding-left:5px"></i></div>
                                <Listbox class="field col-12 md:col-5 fieldLabel" v-model="selectedActivities"
                                    :options="selectedCw?activities:[]" listStyle="max-height:200px" id="aclist"
                                    optionLabel="name" multiple>
                                    <template #empty>
                                        <label>Please select a contruction work</label>
                                    </template>
                                </Listbox>
                                <div class="field col-12 md:col-7 fieldLabel"></div>
                                <label class="field col-12 md:col-5 fieldLabel">{{selectedActivities.length}} Activities
                                    Selected</label>
                            </div>
                        </div>
                        <div class="verticalBoxContainer">
                            <h3>Relationship between Activity and Equipment</h3>
                            <div class="formgrid grid">
                                <Listbox class="field col-12 md:col-5 fieldLabel" v-model="selectedActivity"
                                    :options="activities" listStyle="max-height:200px" id="aclist"
                                    @change="selectedEquipments=selectedActivity.equipments" optionLabel="name">
                                    <template #empty>
                                        <label>Please select a contruction work</label>
                                    </template>
                                </Listbox>
                                <div class="field col-12 md:col-2 center2"><i class="pi pi-angle-double-right"
                                        style="padding-left:5px"></i></div>
                                <Listbox class="field col-12 md:col-5 fieldLabel" v-model="selectedEquipments"
                                    :options="selectedActivity?equipments:[]" listStyle="max-height:200px" id="aclist"
                                    optionLabel="pme" multiple>
                                    <template #empty>
                                        <label>Please select an activity</label>
                                    </template>
                                </Listbox>
                                <div class="field col-12 md:col-7 fieldLabel"></div>
                                <label class="field col-12 md:col-5 fieldLabel">{{selectedEquipments.length}} Equipments
                                    Selected</label>
                            </div>
                        </div> 
                    </TabPanel>-->
                    <TabPanel header="Equipment">
                        <div class="verticalBoxContainer">
                            <h3>Contruction Work, Activity & PME Relationship
                                <i class="pi pi-question-circle" style="padding-left:5px"
                                    v-tooltip="'Please download Contruction Works, Acitivity, PME database to add, edit and delete relationship.'"></i>
                            </h3>
                            <div class="p-fluid formgrid grid">
                                <div class="field col-12 md:col-6 fieldLabel">
                                    <Button label="Download Current Contruction Works, Acitivity, PME Database"
                                        @click="downloadCWActPME"></Button>
                                </div>
                                <div class="field col-12 md:col-6 fieldLabel">
                                    <UploadFile @upload="updateCWActPME"
                                        label="Upload New Contruction Works, Acitivity, PME Database" format=".csv"
                                        style="height:30px;margin: 1%;width:48%" id="updateCWActPME" :multiple="false">
                                    </UploadFile>
                                </div>
                            </div>
                            <label v-if="cwActPMEUpdateResult != ''">{{ cwActPMEUpdateResult }}</label>
                        </div>
                        <div class="verticalBoxContainer">
                            <h3>Equipment
                                <i class="pi pi-question-circle" style="padding-left:5px"
                                    v-tooltip="'To edit existing Equipment, click on the edit button in the table below. To create or delete Equipment, please download Equipment database.'"></i>
                            </h3>
                            <div class="p-fluid formgrid grid">
                                <div class="field col-12 md:col-6 fieldLabel">
                                    <Button label="Download Current Equipment Database"
                                        @click="downloadEquipment"></Button>
                                </div>
                                <div class="field col-12 md:col-6 fieldLabel">
                                    <UploadFile @upload="updateEquipment" label="Upload New Equipment Database"
                                        format=".csv" style="height:30px;margin: 1%;width:48%" id="updateEquipment"
                                        :multiple="false">
                                    </UploadFile>
                                </div>
                                <div v-if="equipmentUpdateResult != ''" class="field col-12 md:col-12 fieldLabel"
                                    style="text-align: center;">
                                    <label style="color:green">{{ equipmentUpdateResult
                                        }}</label>
                                </div>
                                <!-- <Button label="Upload New Equipment Database" style="margin: 1%;width:48%"></Button> -->
                                <DataTable :value="pme" :scrollable="true" scrollHeight="300px" editMode="row"
                                    dataKey="id" v-model:editingRows="pmeEditingRows"
                                    @row-edit-save="onEquipmentRowEditSave" style="width:100%">
                                    <Column field="pme" header="Name" style="max-width:40%;min-width:35%"
                                        :sortable="true">

                                        <template #editor="{ data, field }">
                                            <label>{{ data[field] }}</label>
                                        </template>
                                    </Column>
                                    <Column field="noisePower" header="Default Sound Power" style="max-width:15%"
                                        :sortable="true">

                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" :min="data.noisePowerMin"
                                                :max="data.noisePowerMax" showButtons />
                                        </template>
                                    </Column>
                                    <Column field="noisePowerMin" header="Minimum Sound Power" style="max-width:15%"
                                        :sortable="true">

                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" :min="0" :max="1000" showButtons />
                                        </template>
                                    </Column>
                                    <Column field="noisePowerMax" header="Maximum Sound Power" style="max-width:15%"
                                        :sortable="true">

                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" :min="0" :max="1000" showButtons />
                                        </template>
                                    </Column>
                                    <Column field="percentMin" header="Minimum % on Time in 30 mins"
                                        style="max-width:15%" :sortable="true">

                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" :min="10" :max="100" suffix="%"
                                                showButtons />
                                        </template>

                                        <template #body="slotProps">
                                            <label>{{ slotProps.data.percentMin }}%</label>
                                        </template>
                                    </Column>
                                    <Column :rowEditor="true" style="width:10%; min-width:8rem"
                                        bodyStyle="text-align:center"></Column>
                                </DataTable>
                            </div>
                        </div>
                    </TabPanel>
                </TabView>
            </template>

            <template #footer>
                <div class="footer">
                    <Button label="Close" class="p-button-secondary" style="margin-left: .5em"
                        @click='backToProjects' />
                </div>
            </template>
        </Card>
    </div>
</template>

<script>
import CryptoHelper from '@/helper/CryptoHelper';
import DateHelper from '@/helper/DateHelper';
import UploadFile from '@/components/UploadFile.vue';
import LineChart from '@/components/chart/LineChart.vue';
import BarChart from '@/components/chart/BarChart.vue';

export default {
    name: 'AdminView',
    components: {
        UploadFile,
        LineChart,
        BarChart
    },
    data() {
        return {
            districtAdmins: [],
            adminEditingRows: [],

            allUsers: [],
            filteredUsers: [],
            searchUser: "",
            targetUser: undefined,

            cwActs: [],
            selectedCw: "",
            constructionWorks: [],
            activities: [],
            selectedActivities: [],
            selectedActivity: "",

            equipments: [],
            selectedEquipments: [],

            cwActPMERaw: [],
            cwActPMEUpdateResult: "",

            pme: [],
            pmeEditingRows: [],
            activeIndex: 0,
            equipmentUpdateResult: "",

            //statistics
            allProjects: [],
            userByMonth: { labels: [], datasets: [] },
            companyByMonth: { labels: [], datasets: [] },
            projectByMonth: { labels: [], datasets: [] },
            projectAccumulative: { labels: [], datasets: [] },
            projectByDistrict: { labels: [], datasets: [] }
        }
    },
    computed: {
    },
    methods: {
        csvEscape(value) {
            const stringValue = value == null ? "" : String(value);
            return /[",\n\r]/.test(stringValue)
                ? `"${stringValue.replace(/"/g, '""')}"`
                : stringValue;
        },
        downloadCsv(filename, content) {
            const blob = new Blob(["\uFEFF", content], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.setAttribute("href", url);
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        },
        backToProjects() {
            this.$router.push('/Projects');
        },
        onAdminRowEditSave(event) {
            let { newData, index } = event;
            this.districtAdmins[index] = { ...this.districtAdmins[index], ...newData };
            let props = this;
            let data = {
                ...this.districtAdmins[index],
                password: this.districtAdmins[index].password ? CryptoHelper.Encrypt(this.districtAdmins[index].password, this.districtAdmins[index].guid.replaceAll("-", "")) : null,
            }
            this.axios
                .post(`${this.apiEndpoint}user`, data)
                .then(function (response) {
                })
                .catch(error => console.log(error))
        },
        onEquipmentRowEditSave(event) {
            let { newData, index } = event;
            this.pme[index] = { ...this.pme[index], ...newData };
            this.axios
                .post(`${this.apiEndpoint}pme`, this.pme[index])
                .then(response => {
                })
                .catch((error) => {
                    console.log(error);
                })
        },
        getDistrictAdmins() {
            let props = this;
            this.axios
                .get(`${this.apiEndpoint}user/districtadmins`)
                .then(response => {
                    response.data.forEach(user => {
                        try {
                            user.password = user.password ? CryptoHelper.Decrypt(user.password, user.guid.replaceAll("-", "")) : "";
                        }
                        catch (error) {
                            console.log(error)
                        }
                    })
                    props.districtAdmins = response.data;
                })
        },
        getAllUsers() {
            let props = this;
            this.axios
                .get(`${this.apiEndpoint}user/allusers`)
                .then(response => {
                    props.allUsers = response.data.map(user => {
                        return {
                            ...user,
                            userType: user.userType.replace("Contractor ", ""),
                            registerDate: DateHelper.getDateString(user.createdDate),
                            active: user.active ? "Yes" : "No",
                            deleting: "pi pi-trash"
                        }
                    });
                    props.initUserLineChart();
                })
        },
        getAllProjects() {
            let props = this;
            this.axios
                .get(`${this.apiEndpoint}project`)
                .then(response => {
                    props.allProjects = response.data.map(d => {
                        return {
                            ...d,
                            targetDistrict: d.targetDistrict === "Shatin" ? "Sha Tin" : d.targetDistrict
                        }
                    });
                    props.initProjectLineChart();
                    props.initProjectBarChart();
                })
        },
        searchUsers() {
            let lowerSearch = this.searchUser.toLowerCase();
            return this.allUsers.filter(user =>
                user.company?.toLowerCase().includes(lowerSearch)
                || user.firstName?.toLowerCase().includes(lowerSearch)
                || user.lastName?.toLowerCase().includes(lowerSearch)
                || user.email?.toLowerCase().includes(lowerSearch)
                || user.phone?.toLowerCase().includes(lowerSearch))
        },
        confirmDeleteUser(event) {
            let props = this;
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Do you want to PERMANENTLY DELETE this user?',
                icon: 'pi pi-info-circle',
                acceptClass: 'p-button-danger',
                accept: () => {
                    props.deleteUser();
                },
                reject: () => {

                }
            });
        },
        deleteUser() {
            let props = this;
            console.log(props.targetUser)
            if (props.targetUser) {
                props.targetUser.deleting = "pi pi-spin pi-spinner";
                props.axios
                    .delete(`${props.apiEndpoint}user?guid=${props.targetUser.guid}`)
                    .then(response => {
                        let index = props.allUsers.indexOf(props.targetUser);
                        if (index > -1) {
                            props.allUsers.splice(index, 1);
                        }
                        props.targetUser.deleting = "pi pi-trash";
                    })
                    .catch((error) => {
                        console.log(error);
                        props.targetUser.deleting = "pi pi-trash";
                    })
            }
        },
        initCWActPMEs() {
            let props = this;
            this.axios
                .get(`${this.apiEndpoint}cwactpme?type=cwact`)
                .then(response => {
                    props.cwActs = response.data;
                    props.selectedCw = props.cwActs[0];
                    props.selectedActivities = props.cwActs[0].activities;
                    this.axios
                        .get(`${this.apiEndpoint}cwactpme?type=construction`)
                        .then(response => {
                            props.constructionWorks = response.data;
                            props.constructionWorks.forEach(cw => {
                                cw.equipments.forEach(e => {
                                    e.pme = e.officialId != "" ? `${e.officialId} - ${e.name}` : e.name;
                                })
                            })
                            props.axios
                                .get(`${this.apiEndpoint}cwactpme?type=activities`)
                                .then(response => {
                                    props.activities = response.data;
                                    props.activities.forEach(ac => {
                                        ac.equipments.forEach(e => {
                                            e.pme = e.officialId != "" ? `${e.officialId} - ${e.name}` : e.name;
                                        })
                                    })
                                    props.cwActs.forEach(cwAct => {
                                        cwAct.activities = cwAct.activities.map(ac => {
                                            let filtered = props.activities.filter(a => a.name == ac);
                                            if (filtered.length > 0) {
                                                return props.activities.filter(a => a.name == ac)[0];
                                            }
                                            else {
                                                let newAct = { name: ac, equipments: [] };
                                                props.activities.push(newAct);
                                                props.activities.sort((a, b) => (a.name > b.name) ? 1 : -1);
                                                return newAct;
                                            }
                                        });
                                    })
                                    props.selectedActivity = props.activities[0];
                                    props.selectedEquipments = props.activities[0].equipments;
                                })
                        })
                })
        },
        initEquipments() {
            let props = this;
            props.axios
                .get(`${props.apiEndpoint}pme`)
                .then(function (response) {
                    let all = [];
                    response.data.forEach(e => {
                        e.pme = e.officialId != "" ? `${e.officialId} - ${e.name}` : e.name;
                        props.pme.push(e);
                        all.push(e);
                    })
                    props.pme.sort((a, b) => (a.pme > b.pme) ? 1 : -1);
                    props.pme.forEach(e => {
                        e.required1 = e.required1.map(id => all.filter(e => e.id == id)[0]).sort((a, b) => (a.pme > b.pme) ? 1 : -1);
                        e.required2 = e.required2.map(id => all.filter(e => e.id == id)[0]).sort((a, b) => (a.pme > b.pme) ? 1 : -1);
                        e.required3 = e.required3.map(id => all.filter(e => e.id == id)[0]).sort((a, b) => (a.pme > b.pme) ? 1 : -1);
                    })
                })
                .catch(error => {
                    console.log(error);
                })
        },
        getEquipment() {
            let props = this;
            this.axios
                .get(`${this.apiEndpoint}pme/qpme`)
                .then(response => {
                    props.pme = response.data;
                })
        },
        downloadEquipment() {
            let data = "To edit existing Equipment, please do not edit id column.\nTo add new Equipment, please leave id blank\nTo delete Equipment, simply delete the row.\nid,official ID,name,default sound power,minimum sound power,maximum sound power,minimum % on time in 30 mins,PME/QPME\n";
            for (const e of this.pme.sort((a, b) => (a.id > b.id) ? 1 : -1)) {
                data += [
                    e.id,
                    this.csvEscape(e.officialId),
                    this.csvEscape(e.name),
                    e.noisePower,
                    e.noisePowerMin,
                    e.noisePowerMax,
                    e.percentMin,
                    e.isQPME ? "QPME" : "PME"
                ].join(',');
                data += "\n";
            }
            this.downloadCsv("Equipment Database.csv", data);
        },
        updateEquipment(files) {
            this.equipmentUpdateResult = "";
            let newEquipment = 0;
            let editEquipment = 0;
            let deletedEquipment = 0;
            let file = files[0];
            let props = this;
            const reader = new FileReader();
            reader.onload = function (event) {
                let dataString = event.target.result.replaceAll('\r', '');
                if (!dataString.includes("id,official ID,name,default sound power,minimum sound power,maximum sound power,minimum % on time in 30 mins,PME/QPME")) {
                    alert("Please make sure you upload correct database");
                    return;
                };
                let newEquipments = [];
                let totalUpdate = 0;
                for (var i = 4; i < dataString.split('\n').length; i++) {
                    let line = dataString.split('\n')[i];
                    let cells = line.split(',');
                    if (cells.length < 8) continue;
                    let newData = [];
                    let tempData = [];
                    for (var k = 0; k < cells.length; k++) {
                        if (cells[k] == '""') {
                            newData.push("");
                        }
                        else if (cells[k].charAt(0) == '"') {
                            tempData.push(cells[k]);
                            k++;
                            if (k > cells.length - 1) break;
                            while (cells[k].charAt(cells[k].length - 1) != '"') {
                                tempData.push(cells[k]);
                                k++;
                                if (k > cells.length - 1) break;
                            }
                            tempData.push(cells[k]);
                            newData.push(tempData.join(',').substring(1, tempData.join(',').length - 1));
                            tempData = [];
                        }
                        else {
                            newData.push(cells[k]);
                        }
                    }
                    newEquipments.push({
                        id: newData[0] == "" ? -1 : parseInt(newData[0]),
                        officialId: newData[1],
                        name: newData[2],
                        noisePower: parseInt(newData[3]),
                        noisePowerMin: parseInt(newData[4]),
                        noisePowerMax: parseInt(newData[5]),
                        percentMin: parseInt(newData[6]),
                        isQPME: newData[7] == "QPME"
                    });
                }
                console.log(newEquipments);
                newEquipments.forEach(async e => {
                    e.pme = e.officialId != "" ? `${e.officialId} - ${e.name}` : e.name;
                    let filtered = props.pme.filter(e2 => e2.id == e.id);
                    if (filtered.length == 0) {
                        totalUpdate++;
                        //new pme
                        await props.axios
                            .post(`${props.apiEndpoint}pme`, e)
                            .then(response => {
                                e.id = response.data.id;
                                newEquipment++;
                                props.equipmentUpdateResult = `Successfully added ${newEquipment} new equipment(s), edited ${editEquipment} equipment(s) and deleted ${deletedEquipment} equipment(s).`;
                            })
                            .catch((error) => {
                                console.log(error);
                            })
                    }
                    else if (!(filtered[0].pme == e.pme && filtered[0].noisePower == e.noisePower && filtered[0].noisePowerMin == e.noisePowerMin && filtered[0].noisePowerMax == e.noisePowerMax && filtered[0].percentMin == e.percentMin)) {
                        totalUpdate++;
                        //existing pme with data updated
                        await props.axios
                            .post(`${props.apiEndpoint}pme`, e)
                            .then(response => {
                                editEquipment++;
                                props.equipmentUpdateResult = `Successfully added ${newEquipment} new equipment(s), edited ${editEquipment} equipment(s) and deleted ${deletedEquipment} equipment(s).`;
                            })
                            .catch((error) => {
                                console.log(error);
                            })
                    }
                });
                props.pme.forEach(async e => {
                    let filtered = newEquipments.filter(e2 => e2.id == e.id);
                    if (filtered.length == 0) {
                        totalUpdate++;
                        await props.axios
                            .delete(`${props.apiEndpoint}pme?id=${e.id}`)
                            .then(response => {
                                deletedEquipment++;
                                props.equipmentUpdateResult = `Successfully added ${newEquipment} new equipment(s), edited ${editEquipment} equipment(s) and deleted ${deletedEquipment} equipment(s).`;
                            })
                            .catch((error) => {
                                console.log(error);
                            })
                    }
                })
                if (totalUpdate === 0) {
                    props.equipmentUpdateResult = `No equipments need update.`;
                }
                props.pme = newEquipments;
            };
            reader.readAsText(file);
        },
        getCWActPMERaw() {
            let props = this;
            this.axios
                .get(`${this.apiEndpoint}cwactpmeraw`)
                .then(response => {
                    props.cwActPMERaw = response.data;
                })
        },
        downloadCWActPME() {
            let data = "To edit existing relationship, please do not edit id column.\nTo add new relationship, please leave id blank\nTo delete relationship, simply delete the row.\nid,construction work name,activity name,pme name,pme official id\n";
            for (const e of this.cwActPMERaw.sort((a, b) => (a.id > b.id))) {
                data += [
                    e.id,
                    this.csvEscape(e.cwName),
                    this.csvEscape(e.activityName),
                    this.csvEscape(e.pmeName),
                    this.csvEscape(e.pmeOfficialId)
                ].join(',');
                data += "\n";
            }
            this.downloadCsv("CW Activity PME Database.csv", data);
        },
        updateCWActPME(files) {
            this.cwActPMEUpdateResult = "";
            var newCWActPME = 0;
            var editCWActPME = 0;
            var deletedCWActPME = 0;
            let file = files[0];
            let props = this;
            const reader = new FileReader();
            reader.onload = function (event) {
                let dataString = event.target.result.replaceAll('\r', '');
                if (!dataString.includes("id,construction work name,activity name,pme name,pme official id")) {
                    alert("Please make sure you upload correct database");
                    return;
                };
                let newCWActPMEs = [];
                for (var i = 4; i < dataString.split('\n').length; i++) {
                    let line = dataString.split('\n')[i];
                    let cells = line.split(',');
                    if (cells.length < 5) continue;
                    let newData = [];
                    let tempData = [];
                    for (var k = 0; k < cells.length; k++) {
                        if (cells[k] == '""') {
                            newData.push("");
                        }
                        else if (cells[k].charAt(0) == '"') {
                            tempData.push(cells[k]);
                            k++;
                            if (k > cells.length - 1) break;
                            while (cells[k].charAt(cells[k].length - 1) != '"') {
                                tempData.push(cells[k]);
                                k++;
                                if (k > cells.length - 1) break;
                            }
                            tempData.push(cells[k]);
                            newData.push(tempData.join(',').substring(1, tempData.join(',').length - 1));
                            tempData = [];
                        }
                        else {
                            newData.push(cells[k]);
                        }
                    }
                    newCWActPMEs.push({
                        id: newData[0] == "" ? -1 : parseInt(newData[0]),
                        cwName: newData[1],
                        activityName: newData[2],
                        pmeName: newData[3],
                        pmeOfficialId: newData[4],
                    });
                }
                newCWActPMEs.forEach(async e => {
                    let filtered = props.cwActPMERaw.filter(e2 => e2.id == e.id);
                    if (filtered.length == 0) {
                        //new CWActPME
                        await props.axios
                            .post(`${props.apiEndpoint}cwactpmeraw`, e)
                            .then(response => {
                                e.id = response.data.id;
                                newCWActPME += 1;
                                props.cwActPMEUpdateResult = `Successfully added ${newCWActPME} new relationship(s), edited ${editCWActPME} relationship(s) and deleted ${deletedCWActPME} relationship(s).`;
                            })
                            .catch((error) => {
                                console.log(error);
                            })
                    }
                    else if (!(filtered[0].cwName == e.cwName && filtered[0].activityName == e.activityName && filtered[0].pmeName == e.pmeName && filtered[0].pmeOfficialId == e.pmeOfficialId)) {
                        //existing CWActPME with data updated
                        await props.axios
                            .post(`${props.apiEndpoint}cwactpmeraw`, e)
                            .then(response => {
                                editCWActPME += 1;
                                props.cwActPMEUpdateResult = `Successfully added ${newCWActPME} new relationship(s), edited ${editCWActPME} relationship(s) and deleted ${deletedCWActPME} relationship(s).`;
                            })
                            .catch((error) => {
                                console.log(error);
                            })
                    }
                });
                props.cwActPMERaw.forEach(async e => {
                    let filtered = newCWActPMEs.filter(e2 => e2.id == e.id);
                    if (filtered.length == 0) {
                        await props.axios
                            .delete(`${props.apiEndpoint}cwactpmeraw?id=${e.id}`)
                            .then(response => {
                                deletedCWActPME += 1;
                                props.cwActPMEUpdateResult = `Successfully added ${newCWActPME} new relationship(s), edited ${editCWActPME} relationship(s) and deleted ${deletedCWActPME} relationship(s).`;
                            })
                            .catch((error) => {
                                console.log(error);
                            })
                    }
                })
                props.cwActPMERaw = newCWActPMEs;
            };
            reader.readAsText(file);
        },
        initUserLineChart() {
            const createdDate = this.allUsers.map(u => DateHelper.getDate(u.createdDate))
            const company = [...new Set(this.allUsers.map(u => u.company))]
            const companyCreatedDate = company.map(c => new Date(Math.min(...this.allUsers.filter(u => u.company == c).map(u => DateHelper.getDate(u.createdDate)))))
            const minDate = new Date(Math.min(...createdDate));
            const maxDate = new Date(Math.max(...createdDate));
            let labels = [];
            let userByMonth = [];
            let userAccumulative = [];
            let companyByMonth = [];
            let companyAccumulative = [];
            let lastUserCount = 0;
            let lastCompanyCount = 0;
            let currentMonth = minDate;
            while (currentMonth <= maxDate) {
                const targetMonth = DateHelper.getYearMonthString(currentMonth)
                labels.push(targetMonth);
                const user = this.allUsers.filter(u => DateHelper.getYearMonthString(u.createdDate) === targetMonth).length
                const company = companyCreatedDate.filter(d => DateHelper.getYearMonthString(d) === targetMonth).length
                userByMonth.push(user);
                userAccumulative.push(user + lastUserCount);
                companyByMonth.push(company);
                companyAccumulative.push(company + lastCompanyCount);
                lastUserCount = user + lastUserCount
                lastCompanyCount = company + lastCompanyCount
                currentMonth.setMonth(currentMonth.getMonth() + 1);
            }
            this.userByMonth = {
                labels: labels,
                datasets: [{
                    label: "User Registered",
                    backgroundColor: '#a2afba',
                    borderColor: '#a2afba',
                    data: userByMonth
                }, {
                    label: "Accumulative User Registered",
                    backgroundColor: '#6c757d',
                    borderColor: '#6c757d',
                    data: userAccumulative
                }]
            }
            this.companyByMonth = {
                labels: labels,
                datasets: [{
                    label: "Company Registered",
                    backgroundColor: '#a2afba',
                    borderColor: '#a2afba',
                    data: companyByMonth
                }, {
                    label: "Accumulative Company Registered",
                    backgroundColor: '#6c757d',
                    borderColor: '#6c757d',
                    data: companyAccumulative
                }]
            }
        },
        initProjectLineChart() {
            const createdAt = this.allProjects.map(u => DateHelper.getDate(u.createdAt))
            const minDate = new Date(new Date(Math.min(...createdAt)).setDate(1));
            const maxDate = new Date();
            let labels = [];
            let create = [];
            let submit = [];
            let approve = [];
            let createAccumulative = [];
            let submitAccumulative = [];
            let approveAccumulative = [];
            let lastCreatedCount = 0;
            let lastSubmittedCount = 0;
            let lastApprovedCount = 0;
            let currentMonth = minDate;
            let total = 0
            while (currentMonth <= maxDate) {
                const targetMonth = DateHelper.getYearMonthString(currentMonth)
                labels.push(targetMonth);
                const created = this.allProjects.filter(p => DateHelper.getYearMonthString(p.createdAt) === targetMonth && !p.submitted && !p.approved).length
                const submitted = this.allProjects.filter(p => DateHelper.getYearMonthString(p.createdAt) === targetMonth && p.submitted && !p.approved).length
                const approved = this.allProjects.filter(p => DateHelper.getYearMonthString(p.createdAt) === targetMonth && p.submitted && p.approved).length
                total += this.allProjects.filter(p => DateHelper.getYearMonthString(p.createdAt) === targetMonth && !p.submitted && !p.approved).length
                total += this.allProjects.filter(p => DateHelper.getYearMonthString(p.createdAt) === targetMonth && p.submitted && !p.approved).length
                total += this.allProjects.filter(p => DateHelper.getYearMonthString(p.createdAt) === targetMonth && p.submitted && p.approved).length
                create.push(created)
                submit.push(submitted)
                approve.push(approved)
                createAccumulative.push(created + lastCreatedCount)
                submitAccumulative.push(submitted + lastSubmittedCount)
                approveAccumulative.push(approved + lastApprovedCount)
                lastCreatedCount = created + lastCreatedCount
                lastSubmittedCount = submitted + lastSubmittedCount
                lastApprovedCount = approved + lastApprovedCount
                currentMonth.setMonth(currentMonth.getMonth() + 1);
            }
            this.projectByMonth = {
                labels: labels,
                datasets: [{
                    label: "Created",
                    backgroundColor: '#f7ca35',
                    borderColor: '#f7ca35',
                    data: create
                }, {
                    label: "Submitted",
                    backgroundColor: '#4FA8F9',
                    borderColor: '#4FA8F9',
                    data: submit
                }, {
                    label: "Apprvoed",
                    backgroundColor: '#559b1a',
                    borderColor: '#559b1a',
                    data: approve
                }]
            }
            this.projectAccumulative = {
                labels: labels,
                datasets: [{
                    label: "Created",
                    backgroundColor: '#f7ca35',
                    borderColor: '#f7ca35',
                    data: createAccumulative
                }, {
                    label: "Submitted",
                    backgroundColor: '#4FA8F9',
                    borderColor: '#4FA8F9',
                    data: submitAccumulative
                }, {
                    label: "Apprvoed",
                    backgroundColor: '#559b1a',
                    borderColor: '#559b1a',
                    data: approveAccumulative
                }]
            }
            console.log("total line", total)
        },
        initProjectBarChart() {
            let total = 0
            const districts = [
                "Central & Western",
                "Wan Chai",
                "Eastern",
                "Southern",
                "Yau Tsim Mong",
                "Sham Shui Po",
                "Kowloon City",
                "Wong Tai Sin",
                "Kwai Tsing",
                "Tsuen Wan",
                "Tuen Mun",
                "Yuen Long",
                "Tai Po",
                "Kwun Tong",
                "North",
                "Sha Tin",
                "Sai Kung",
                "Islands"
            ].sort();
            let create = [];
            let submit = [];
            let approve = [];
            districts.forEach(d => {
                create.push(this.allProjects.filter(p => p.targetDistrict.split(",").includes(d) && !p.submitted && !p.approved).length)
                submit.push(this.allProjects.filter(p => p.targetDistrict.split(",").includes(d) && p.submitted && !p.approved).length)
                approve.push(this.allProjects.filter(p => p.targetDistrict.split(",").includes(d) && p.submitted && p.approved).length)
                total += this.allProjects.filter(p => p.targetDistrict.split(",").includes(d) && !p.submitted && !p.approved).length
                total += this.allProjects.filter(p => p.targetDistrict.split(",").includes(d) && p.submitted && !p.approved).length
                total += this.allProjects.filter(p => p.targetDistrict.split(",").includes(d) && p.submitted && p.approved).length
            })
            this.projectByDistrict = {
                labels: districts,
                datasets: [{
                    label: "Created",
                    backgroundColor: '#f7ca35',
                    borderColor: '#f7ca35',
                    data: create
                }, {
                    label: "Submitted",
                    backgroundColor: '#4FA8F9',
                    borderColor: '#4FA8F9',
                    data: submit
                }, {
                    label: "Apprvoed",
                    backgroundColor: '#559b1a',
                    borderColor: '#559b1a',
                    data: approve
                }]
            }
            console.log("total bar", total)
        },
        exportProjects() {
            let data = "Project Title,Project Owner,District,Status,Created At\n";
            for (const p of this.allProjects.sort((a, b) => (a.ownerCompany > b.ownerCompany) ? 1 : -1)) {
                let status = ""
                if (!p.submitted && !p.approved) {
                    status = "Created"
                }
                else if (p.submitted && !p.approved) {
                    status = "Submitted"
                }
                else if (p.submitted && p.approved) {
                    status = "Approved"
                }
                data += [
                    this.csvEscape(p.projectTitle),
                    this.csvEscape(p.ownerCompany),
                    this.csvEscape(p.targetDistrict),
                    this.csvEscape(status),
                    this.csvEscape(p.createdAt)
                ].join(',');
                data += "\n";
            }
            this.downloadCsv("Projects.csv", data);
        },
        exportUsers() {
            let data = "User Company,Registered At\n";
            for (const u of this.allUsers.sort((a, b) => (a.createdDate > b.createdDate) ? 1 : -1)) {
                data += [this.csvEscape(u.company), this.csvEscape(u.createdDate)].join(',');
                data += "\n";
            }
            this.downloadCsv("Users.csv", data);
        }
    },
    mounted() {
        this.getDistrictAdmins();
        this.getAllUsers();
        this.getAllProjects();
        // this.initCWActPMEs();
        this.initEquipments();
        this.getCWActPMERaw();
        // this.getEquipment();
    }
}
</script>



<style scoped>
.center {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.card {
    width: 1200px;
    max-width: 90vw;
}

.footer {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
}

.input {
    margin-top: 10px;
}

.center2 {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
}

.verticalBoxContainer {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    border: 1px solid #ced4da;
    border-radius: 3px;
    margin: 5px;
    height: 100%;
}
</style>